import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { CostCentersTable } from '~/components/settings/masterData/costCenter/CostCentersTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute(
  '/(main)/settings/masterdata/cost-centers/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/cost-centers',
    ...routeParams,
  }),
  component: CostCentersTable,
  validateSearch,
});

export const MASTERDATA_COST_CENTERS = buildRouteExport({
  Route,
  ...routeParams,
});
